import { render, staticRenderFns } from "./Glory.vue?vue&type=template&id=2d020612&scoped=true&"
import script from "./Glory.vue?vue&type=script&lang=js&"
export * from "./Glory.vue?vue&type=script&lang=js&"
import style0 from "./Glory.vue?vue&type=style&index=0&id=2d020612&prod&lang=css&"
import style1 from "./Glory.vue?vue&type=style&index=1&id=2d020612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d020612",
  null
  
)

export default component.exports